exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dominantCategoriesModal__modalBody___LTFHI {\n  display: flex;\n  flex-direction: column;\n  gap: 16px; }\n\n.dominantCategoriesModal__field___1DPfx {\n  display: flex;\n  flex-direction: column;\n  gap: 6px; }\n\n.dominantCategoriesModal__label___Pk9wY {\n  font-weight: 500;\n  font-size: 14px;\n  color: #3f3f3f; }\n\n.dominantCategoriesModal__select___1tAbw {\n  width: 100%; }\n", ""]);

// exports
exports.locals = {
	"modalBody": "dominantCategoriesModal__modalBody___LTFHI",
	"field": "dominantCategoriesModal__field___1DPfx",
	"label": "dominantCategoriesModal__label___Pk9wY",
	"select": "dominantCategoriesModal__select___1tAbw"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/DominantCategoriesModal/dominantCategoriesModal.scss
// module id = 4884
// module chunks = 6